import React from 'react';
import PropTypes from 'prop-types';

import { TextInput } from '../../../../components/Inputs/TextInput';
import accessStyles from '../AccessSimulator/AccessSimulator.module.scss';

// Draft values are the text the tester typed; these convert them for the API.
export const toTextOrNull = value => {
  const text = String(value ?? '').trim();
  return text === '' ? null : text;
};

export const toIntOrNull = value => {
  const text = String(value ?? '').trim();
  return text === '' ? null : Number(text);
};

/** A labelled TextInput in the simulator modals' field grid. */
export function DraftField({ id, label, value, onChange, type, disabled, placeholder }) {
  return (
    <label className={accessStyles.patientModalField} htmlFor={id}>
      {label}
      <TextInput
        id={id}
        type={type || 'text'}
        value={value ?? ''}
        placeholder={placeholder}
        onChange={event => onChange(event.target.value)}
        disabled={disabled}
      />
    </label>
  );
}

DraftField.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};
